import { render, staticRenderFns } from "./AnalyticsResultChartsPatientStatusDaysFromAdmissionToDischarge.vue?vue&type=template&id=74563d5c&scoped=true"
import script from "./AnalyticsResultChartsPatientStatusDaysFromAdmissionToDischarge.vue?vue&type=script&lang=js"
export * from "./AnalyticsResultChartsPatientStatusDaysFromAdmissionToDischarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74563d5c",
  null
  
)

export default component.exports